import { BrowserRouter } from 'react-router-dom'
import { AppRoutes } from './router'
import { AuthProvider } from './features/user-dashboard/auth/AuthContext'
import { ThemeProvider } from './features/shared/theme/ThemeContext'
import DisplayScaleProvider from './features/shared/components/DisplayScaleProvider'


function App() {
  return (
    <BrowserRouter basename={__BASE_PATH__}>
      <AuthProvider>
        <ThemeProvider>
          <DisplayScaleProvider>
            <AppRoutes />
          </DisplayScaleProvider>
        </ThemeProvider>
      </AuthProvider>
    </BrowserRouter>
  )
}

export default App